import React, { FC } from 'react'
import { Tag, Tooltip } from 'antd'

export type ConnectivityMode = 'onomondo' | 'direct'

const MODE_PRESENTATION: Record<ConnectivityMode, { label: string; color: string; tooltip: string }> = {
    onomondo: {
        label: 'Onomondo',
        color: 'blue',
        tooltip: 'Onomondo connectivity — OTA is pushed to the device',
    },
    direct: {
        label: 'Direct',
        color: 'gold',
        tooltip: 'Direct (local SIM) — the device pulls and self-applies the OTA',
    },
}

export const isKnownMode = (connectivityMode?: string): connectivityMode is ConnectivityMode =>
    connectivityMode === 'onomondo' || connectivityMode === 'direct'

interface Props {
    connectivityMode?: string
}

export const ConnectivityModeTag: FC<Props> = ({ connectivityMode }) => {
    if (!isKnownMode(connectivityMode)) {
        return null
    }
    const { label, color, tooltip } = MODE_PRESENTATION[connectivityMode]
    return (
        <Tooltip title={tooltip}>
            <Tag color={color}>{label}</Tag>
        </Tooltip>
    )
}
